import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { Component } from 'react';
import PropTypes from 'prop-types';
export var IfFeature = /*#__PURE__*/function (_Component) {
  function IfFeature() {
    _classCallCheck(this, IfFeature);
    return _callSuper(this, IfFeature, arguments);
  }
  _inherits(IfFeature, _Component);
  return _createClass(IfFeature, [{
    key: "render",
    value: function render() {
      if (!this.props.isOn) {
        return null;
      }
      return this.props.children;
    }
  }]);
}(Component);
_defineProperty(IfFeature, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isOn: PropTypes.bool
});
_defineProperty(IfFeature, "defaultProps", {
  children: null,
  isOn: false
});
export default IfFeature;